const stack = [
  {
    urlName: "example.com",
    desc: "A JavaScript library for building user interfaces.",
    url: "https://example.com/",
    image: "/images/stack/210x40.webp",
  },
  {
    urlName: "example.com",
    desc: "A platform for building mobile and desktop web applications.",
    url: "https://example.com/",
    image: "/images/stack/210x40.webp",
  },
  {
    urlName: "example.com",
    desc: "A progressive JavaScript framework for building UIs.",
    url: "https://example.com/",
    image: "/images/stack/210x40.webp",
  },
  {
    urlName: "example.com",
    desc: "JavaScript runtime built on Chrome's V8 engine.",
    url: "https://example.com/",
    image: "/images/stack/210x40.webp",
  },
  {
    urlName: "example.com",
    desc: "A high-level Python web framework.",
    url: "https://example.com/",
    image: "/images/stack/210x40.webp",
  },
  {
    urlName: "example.com",
    desc: "A micro web framework written in Python.",
    url: "https://example.com/",
    image: "/images/stack/210x40.webp",
  },
  {
    urlName: "example.com",
    desc: "A server-side web application framework written in Ruby.",
    url: "https://example.com/",
    image: "/images/stack/210x40.webp",
  },
  {
    urlName: "example.com",
    desc: "A PHP framework for web artisans.",
    url: "https://example.com/",
    image: "/images/stack/210x40.webp",
  },
  {
    urlName: "example.com",
    desc: "A framework for building Java applications.",
    url: "https://example.com/",
    image: "/images/stack/210x40.webp",
  },
];

export default stack;